import React, { useState } from "react";
import dayjs, { Dayjs } from "dayjs";
import {
  Box,
  Button,
  Grid,
  TextField,
  Typography,
  CircularProgress,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import axiosInterceptorInstance from "../../../utils/axios.interceptor";
import { toast } from "react-toastify";
import { motion } from "framer-motion";

const SentimentCategories = () => {
  const [data, setData] = useState<any>(null);
  const [msisdn, setMsisdn] = useState<string>("");
  const [date, setDate] = useState<Dayjs | null>(null);
  const [action, setAction] = useState<Boolean>(false);
  const cardColors = [
    { background: "#E3F2FD", accent: "#1976D2" },
    { background: "#F3E5F5", accent: "#8E24AA" },
    { background: "#E8F5E9", accent: "#2E7D32" },
    { background: "#FFF3E0", accent: "#EF6C00" },
    { background: "#FCE4EC", accent: "#C2185B" },
    { background: "#E0F7FA", accent: "#00838F" },
  ];

  const handleGetBundles = async () => {
    setData(null);
    toast.dismiss();
    if (msisdn.trim().length > 9 && date !== null) {
      setAction(true);
      requestBundles();
    } else {
      toast.error("Please select required fields");
    }
  };

  const requestBundles = async () => {
    await axiosInterceptorInstance
      .get(
        `/dashboard/SentimentCategory?Msisdn=${msisdn.trim()}&Date=${date?.format("MMMM YYYY")}`,
      )
      .then((res: any) => {
        setAction(false);
        const responseBody = JSON.parse(res.data.body);

        if (responseBody?.data == null) {
          toast.info("No record found.");
          return;
        }
        setData(responseBody.data);
      })
      .catch((error: any) => {
        setAction(false);
        toast.error(error.message);
      });
  };
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ ease: "linear", duration: 0.5 }}
    >
      <div className="boxShadow">
        <h2 className="sectionTitle">Sentiment Score & Categories</h2>
        <div className="boxInner">
          <Grid container spacing={2}>
            <Grid item xs={5}>
              <TextField
                className="formControl"
                label="Msisdn"
                variant="outlined"
                defaultValue={msisdn}
                onChange={(e) => setMsisdn(e.target.value)}
                inputProps={{ maxLength: 20 }}
              />
            </Grid>
            <Grid item xs={5}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Start Month and Year"
                  value={date}
                  onChange={setDate}
                  minDate={dayjs().startOf("year")}
                  openTo="year"
                  views={["year", "month"]}
                  format="MMMM YYYY"
                  sx={{ width: "100%" }}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={2}>
              {!action && (
                <Button
                  onClick={handleGetBundles}
                  className="dButton dButton2"
                  variant="contained"
                >
                  Search
                </Button>
              )}
              {action && (
                <Button className="dButton dButton2" variant="contained">
                  <CircularProgress color="inherit" size={30} />
                </Button>
              )}
            </Grid>
          </Grid>
        </div>
      </div>

      {data !== null && (
        <Grid container spacing={2}>
          {Object.entries(data)?.map(([label, value], index) => {
            const color = cardColors[index % cardColors.length];

            return (
              <Grid item xs={12} sm={6} md={4} key={label}>
                <Box
                  sx={{
                    height: "100%",
                    minHeight: 110,
                    p: 2.5,
                    borderRadius: 2,
                    borderLeft: `6px solid ${color.accent}`,
                    backgroundColor: color.background,
                    boxShadow: "0 3px 10px rgba(0, 0, 0, 0.08)",
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{ color: "text.secondary", mb: 1 }}
                  >
                    {label}
                  </Typography>
                  <Typography
                    variant="h6"
                    sx={{ color: color.accent, fontWeight: 700 }}
                  >
                    {String(value)}
                  </Typography>
                </Box>
              </Grid>
            );
          })}
        </Grid>
      )}
    </motion.div>
  );
};

export default SentimentCategories;
